import { orchestrator } from "satcheljs";

import { loadPlaceFailed } from "places-explore-operations";
import { addServiceCallsCompleted } from "../store";

orchestrator(loadPlaceFailed, ({ buildingId }) => {
    addServiceCallsCompleted(buildingId, false);
});
